// extracted by mini-css-extract-plugin
export var actions = "_77-8";
export var arrow = "_77-5";
export var card = "_77-0";
export var cardWrapper = "_77-9";
export var fieldName = "_77-3";
export var newValue = "_77-6";
export var oldValue = "_77-4";
export var orangeGlowFade = "_77-c";
export var productSection = "_77-1";
export var scrollToBottom = "_77-b";
export var scrollToBottomAnchor = "_77-a";
export var scrollToBottomIcon = "_77-d";
export var showAllButton = "_77-7";
export var table = "_77-2";